import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5400975c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "custom-style-item"
};
const _hoisted_2 = {
  class: "sub-brand-name"
};
const _hoisted_3 = {
  class: "info-warp"
};
const _hoisted_4 = {
  class: "brand-info"
};
const _hoisted_5 = {
  class: "placeholder-name"
};
const _hoisted_6 = {
  class: "logo"
};
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'customStyleItem',
  props: {
    subBrandInfo: {
      type: Object,
      default: null
    }
  },

  setup(__props) {
    const props = __props; //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = (e, option = {
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'Microsoft YaHei'
    }) => {
      const target = e.target;
      const width = getTextWidth(target.innerText, option);
      tipDisabled.value = target.offsetWidth < width;
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MPopper, {
        disabled: tipDisabled.value,
        placement: "top",
        trigger: "hover",
        content: __props.subBrandInfo && __props.subBrandInfo.subAgentName
      }, {
        reference: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[0] || (_cache[0] = $event => showTextTip($event, {
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: 'Microsoft YaHei'
          })),
          class: "item-name"
        }, _toDisplayString(__props.subBrandInfo && __props.subBrandInfo.subAgentName == null ? 'MyLink' : __props.subBrandInfo.subAgentName), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_MPopper, {
        disabled: tipDisabled.value,
        placement: "top",
        trigger: "hover",
        content: __props.subBrandInfo && __props.subBrandInfo.name
      }, {
        reference: _withCtx(() => [_createElementVNode("span", {
          class: "brand-name",
          onMouseover: _cache[1] || (_cache[1] = $event => showTextTip($event, {
            fontSize: '20px',
            fontWeight: 600,
            fontFamily: 'Microsoft YaHei'
          }))
        }, _toDisplayString(__props.subBrandInfo && __props.subBrandInfo.name), 33)]),
        _: 1
      }, 8, ["disabled", "content"]), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('定制名称')), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(MyLoadingImage, {
        style: {
          "border-radius": "15px"
        },
        width: "72px",
        height: "72px",
        src: __props.subBrandInfo && __props.subBrandInfo.logo || ''
      }, null, 8, ["src"])])])]);
    };
  }

});